import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceModelSeries: null,
  deviceModelList: null,
};

const deviceModelSlice = createSlice({
  name: 'deviceModel',
  initialState,
  reducers: {
    cleanAll(state) {
      Object.assign(state, initialState)
    },
    setAll(state, action) {
      Object.assign(state, action.payload);
    },
   },
  extraReducers: {
  }
});

export const deviceModelActions = deviceModelSlice.actions;

export default deviceModelSlice;